import React, { Component } from 'react';

const FavoritesContext = React.createContext({});

export class FavoritesProvider extends Component {

	constructor (props) {
		super(props);

		this.state = {
			pages: []
		};
	}


	/**
	 * componentDidMount
	 */
	componentDidMount () {
		if (this.getFavorites()) {
			this.setState({
				pages: JSON.parse(this.getFavorites())
			});
		}
	}


	/**
	 * Returns saved favorites from localStorage
	 */
	getFavorites () {
		return localStorage.getItem('favorites');
	}


	/**
	 * Saves favorites to localStorage
	 * @param {Array} favorites - Array of page items
	 */
	saveFavorites(favorites) {
		localStorage.setItem('favorites', JSON.stringify(favorites));
	}


	/**
	 * Adds a page to state/localStorage
	 * @param {Object} page - The page: { title, url }
	 */
	addPage = (page) => {
		let favorites = this.getFavorites();
		
		if (favorites && favorites.indexOf(page.title) !== -1) {
			return;
		}

		favorites = favorites === null ? [] : JSON.parse(favorites);
		favorites.push(page);

		this.saveFavorites(favorites);
		this.setState({
			pages: [ ...this.state.pages, page ]
		});
	}


	/**
	 * Removes a page from state/localStorage
	 * @param {String} url - The url for the page to remove
	 */
	removePage = (url) => {
		const updatedPages = this.state.pages.filter((page) => page.url !== url);

		this.saveFavorites(updatedPages);
		this.setState({
			pages: this.state.pages.filter((item) => item.url !== url)
		});
	}


	/**
	 * The render function
	 */
	render () {
		const { children } = this.props;

		return (
			<FavoritesContext.Provider
				value={{
					pages: this.state.pages,
					addPage: this.addPage,
					removePage: this.removePage
				}}
			>
				{ children }
			</FavoritesContext.Provider>
		);
	}
}

export const FavoritesConsumer = FavoritesContext.Consumer;